const TEMPLATE_NAME = 'PAD_MONITORING_VISITS';

const initialState = () => ({
  loading: false,
  data: {
    visits: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${TEMPLATE_NAME}_FULFILLED`: {
      const newData = action.payload;

      return {
        ...state,
        loading: false,
        data: {
          visits: [...newData]
        }
      };
    }
    case `${TEMPLATE_NAME}_RESUME`: {
      const newData = action.payload;

      return {
        ...state,
        loading: false,
        data: {
          visits: [...newData]
        }
      };
    }
    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }
    default:
      return state;
  }
};
export default reducer;
